



























import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator'
const VForm = require('vuetify/lib/components/VForm')

@Component
export default class AddDialog extends Vue {
  $refs!: {
    form: typeof VForm
  }

  @Prop(Boolean) dialog!: boolean
  @Prop(String) readonly title!: string

  private valid: boolean = true

  @Emit()
  private save(): boolean {
    if (this.$refs.form.validate()) {
      return true
    }

    return false
  }

  @Watch('dialog')
  onDialogChanged() {
    if (!this.dialog) {
      setTimeout(() => {
        this.$refs.form.reset()
      }, 300)
    }
  }
}
